// #region License

/**
 * @license
 * Copyright (C) JVS-Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import { getEnv } from '@mairistem/finances-utils';

import { isProduction } from '@mairistem/tools';
import * as Sentry from '@sentry/react';
import pkg from '../package.json';

export const initialize = () => {
	if (isProduction()) {
		Sentry.init({
			dsn: 'https://b39ad0c52b04ce1b771e56025a63620c@sentry.jvs-mairistem.dev/7',
			environment: getEnv(),
			integrations: [
				Sentry.browserProfilingIntegration(),
				Sentry.browserTracingIntegration(),
				Sentry.replayIntegration({
					blockAllMedia: true,
					maskAllText: true,
				}),
			],
			release:
				getEnv() === 'development'
					? `${pkg.name.replace(/^@[\w-]+(\.)?[\w-]+\//, '')}@dev`
					: `${pkg.name.replace(/^@[\w-]+(\.)?[\w-]+\//, '')}@${pkg.version}`,
			// Session Replay
			replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
			replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
			// Setting this option to true will send default PII data to Sentry.
			// For example, automatic IP address collection on events
			sendDefaultPii: true,
			// Tracing
			tracesSampleRate: 1.0, //  Capture 100% of the transactions
			// Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
			tracePropagationTargets: [
				'localhost',
				/^https:\/\/execution-budgetaire\.((dev|pp|qa)\.jvs-mairistem\.dev|jvsonline\.fr)\/api/,
			],
			profilesSampleRate: 1.0,
		});
	}
};

export default isProduction() ? Sentry : null;
